export default __webpack_public_path__ + "static/media/image6.592454e7.webp";